import { render, staticRenderFns } from "./SaveAsPdf.vue?vue&type=template&id=2cd3d90e&scoped=true"
import script from "./SaveAsPdf.vue?vue&type=script&lang=js"
export * from "./SaveAsPdf.vue?vue&type=script&lang=js"
import style0 from "./Save.scss?vue&type=style&index=0&id=2cd3d90e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd3d90e",
  null
  
)

export default component.exports